import React from 'react';
import { Wrench, ArrowRight } from 'lucide-react';
import { useDbNavigate } from '../../context/DatabaseContext';

const toolGroups = [
  {
    id: 'utilities-tools',
    label: 'Utilities',
    icon: Wrench,
    tools: [
      {
        slug: 'import-template',
        label: 'Bulk Import',
        description: 'Import records in bulk via Excel template. Validates data against existing records, resolves FK display values to IDs, and executes INSERT/UPDATE operations across all configured tables.'
      },
      {
        slug: 'power-query',
        label: 'Power Query',
        description: 'Ad-hoc query interface for direct database exploration. Build and run queries against project data with configurable output and export options.'
      }
    ]
  }
];

const UtilitiesDashboardPage = () => {
  const navigate = useDbNavigate();
  const totalTools = toolGroups.reduce((sum, g) => sum + g.tools.filter(t => !t.future).length, 0);

  return (
    <div className="stui-dashboard-body">
      <div className="stui-dashboard-header">
        <Wrench size={20} className="stui-dashboard-header-icon" />
        <h1 className="stui-dashboard-header-title">Utilities</h1>
        <span className="stui-dashboard-header-subtitle">{totalTools} tools available</span>
      </div>

      <div className="stui-dashboard-groups">
        {toolGroups.map(group => {
          const GroupIcon = group.icon;
          const activeTools = group.tools.filter(t => !t.future);
          return (
            <div key={group.id}>
              <div className="stui-dashboard-group-header">
                <GroupIcon size={16} className="stui-dashboard-header-icon" />
                <span className="stui-dashboard-group-title">{group.label}</span>
                <span className="stui-dashboard-group-count">
                  {activeTools.length} {activeTools.length === 1 ? 'tool' : 'tools'} available
                </span>
              </div>
              <div className="stui-dashboard-tile-grid">
                {group.tools.map(tool => (
                  <div
                    key={tool.slug}
                    className={`stui-tile${tool.future ? ' disabled' : ' stui-clickable'}`}
                    onClick={() => !tool.future && navigate(`/${tool.slug}`)}
                  >
                    <div className="stui-tile-header">
                      <span className="stui-tile-title">{tool.label}</span>
                      {tool.future
                        ? <span className="stui-dashboard-tile-badge">Coming soon</span>
                        : <ArrowRight size={16} className="stui-dashboard-tile-action" />
                      }
                    </div>
                    <div className="stui-dashboard-tile-content">
                      <p className="stui-dashboard-tile-description">{tool.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UtilitiesDashboardPage;
